import { render, staticRenderFns } from "./admin-categories.vue?vue&type=template&id=4b31fd9c&scoped=true"
import script from "./admin-categories.vue?vue&type=script&lang=js"
export * from "./admin-categories.vue?vue&type=script&lang=js"
import style0 from "./admin-categories.vue?vue&type=style&index=0&id=4b31fd9c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b31fd9c",
  null
  
)

export default component.exports